/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var sidebarCart = document.getElementById("sidebar-cart");

if (sidebarCart) {

    sidebarCart.addEventListener("change", function(e) {

        const target = e.target.closest("#agree");
      const targetReturn = e.target.closest("#accept-return-policy");
      const targetPrivacy = e.target.closest("#accept-privacy-policy");
        if (target || targetReturn || targetPrivacy) {
            let submit = sidebarCart.querySelector('.Cart__Checkout');

            var checkbox = sidebarCart.querySelector("input[name=agree]");
            var checkboxReturn = sidebarCart.querySelector("input[name=accept-return-policy]");
            var checkboxPrivacy = sidebarCart.querySelector("input[name=accept-privacy-policy]");
          
            if (checkbox.checked && checkboxPrivacy.checked && checkboxReturn.checked) {
                console.log("Checkbox is checked..");
                submit.disabled = false;
                //submit.classList.remove("disabled")
            } else {
                console.log("Checkbox is not checked..");
                submit.disabled = true;
                //submit.classList.add("disabled")

            }
        }

    });


    sidebarCart.addEventListener("click", function(e) {
        const target = e.target.closest(".Cart__Checkout ");
        if (target) {
            let agreed = sidebarCart.querySelector('#agree').checked
            let agreedReturn = sidebarCart.querySelector('#accept-return-policy').checked
            let agreedPrivacy = sidebarCart.querySelector('#accept-privacy-policy').checked
            let submit = sidebarCart.querySelector('.Cart__Checkout');

            if (agreed && agreedReturn && agreedPrivacy) {
                submit.disabled = false;
                console.log('disable false');
            } else {
                submit.disabled = true;
                console.log('disable true');

            }
        }
    });
}